import { render } from "./MoneyWars.vue?vue&type=template&id=4f57fa9c"
import script from "./MoneyWars.vue?vue&type=script&lang=js"
export * from "./MoneyWars.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__